import { EventStatusEnum } from "../Enums/EventStatusEnum";

export class SearchEventModel {
  public name: string = '';
  public status : number = EventStatusEnum.Active;
  public pageSize: number = 10;
  public pageNumber: number = 1;
}
